export enum BotSessionState {
  IDLE = 'IDLE',
  WATCHING = 'WATCHING',
  // not a state of the underlying state machine — display-only override
  // when a session cannot fire as configured (e.g. AUTO_BUY but no rebalancing target).
  ERROR = 'ERROR',
}
